import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import './UserDashboard.scss';
import { SideBarTab } from '../../components/DashboradSideBar/DashboradSideBar';
import { SideBariTabList } from '../../components/DashboradSideBar/DashboradSideBar';
import DashboardToolbar from '../../components/DashboardToolbar/DashboardToolbar';
import DashboradContentBar from '../../components/DashboradContentbar/DashboradContentBar';
import DashboradSideBar from '../../components/DashboradSideBar/DashboradSideBar';

class UserDashbord extends Component {
  state = {
    activeIndex: 0
  };

  selectTabIndex = activeIndex => {
    this.setState({
      activeIndex
    });
  };

  render() {
    const { isAuthenticated } = this.props;
    const { activeIndex } = this.state;

    let redirect;
    if (!isAuthenticated) {
      redirect = <Redirect to={'/login'} />;
    }

    return (
      <>
        {redirect}
        <DashboardToolbar name={this.props.match.params.id} />
        <div className="userDashboardContent">
          <DashboradSideBar
            activeIndex={activeIndex}
            selectTabIndex={this.selectTabIndex}>
            <SideBariTabList>
              <SideBarTab>Statistics</SideBarTab>
              <SideBarTab>Favorites</SideBarTab>
            </SideBariTabList>
          </DashboradSideBar>
          <DashboradContentBar activeIndex={activeIndex} />
        </div>
      </>
    );
  }
}

const mapStateToProps = state => ({
  isAuthenticated: state.authReducer.token !== null
});

const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserDashbord);
